import Api from './ApiService'

export default {
    get(keyword, pageNumber, filters, order) {
        const params = new URLSearchParams();

        params.append('keyword', keyword);
        params.append('pageNumber', pageNumber);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get(`admins`, { params });
    },
    export(keyword, filters, order) {
        const params = new URLSearchParams();
        params.append('keyword', keyword);
        params.append('export', true);
        params.append('orderColumn', order.column);
        params.append('orderSort', order.sort);

        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.append(`${key}[]`, value);
            });
        });

        return Api().get('admins', {
            params,
            responseType: 'blob'
        });
    },
    getOne(id) {
        return Api().get(`admins/${id}`);
    },
    create(data) {
        return Api().post('admins', data);
    },
    update(id, data) {
        return Api().put(`admins/${id}`, data);
    },
    updatePermissions(id, data) {
        return Api().put(`admins/${id}/permissions`, data);
    }
}